if (!customElements.get('swymcs-watchlist-button')) {
  class SwymCSWatchlistButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.render();
      this.setupCallbacks();
      this.setupEventListeners();

      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const variantId = data.variant.id;
        const availability = data.variant.available;
        this.setAttribute('variant-id', variantId);

        if (availability) {
          this.button.classList.add('swym-hide-button');
        } else {
          this.button.classList.remove('swym-hide-button');
        }
      });
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    render() {
      const isAvailable = this.getAttribute('available') === 'true';

      const buttonHTML = `
                <style>
                    .swymcs-notify-button{
                        margin-bottom: 1rem;
                    }
                    .swym-hide-button {
                        display: none;
                    }
                </style>
                <button style="margin-top:5px; background-color: #018849; color: white;"
                class="swymcs-notify-button button button--full-width button--secondary ${
                  isAvailable ? 'swym-hide-button' : ''
                }"
                >
                Notify Me When Available
                </button>
            `;

      this.innerHTML = buttonHTML;
      this.button = this.querySelector('button');
    }

    setupCallbacks() {
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }

      window.SwymCallbacks.push((swat) => {
        this.addSwymVariantChangedEvent(swat);
      });
    }

    setupEventListeners() {
      this.button.addEventListener('click', (e) => this.handleClick(e));
    }

    async handleClick(event) {
      event.preventDefault();

      const productId = +this.getAttribute('product-id');
      const variantId = +this.getAttribute('variant-id');
      const productUrl = this.getAttribute('product-url');

      if (!window._swat) return;

      const productJSON = await this.fetchProductData(productUrl);
      if (!productJSON) return;

      const variant = productJSON.variants.find((v) => v.id === variantId);
      if (!variant) return;

      const params = {
        empi: productId,
        epi: variantId,
        du: productUrl,
        pr: SwymUtils.formatProductPrice(variant.price),
        iu: productJSON.featured_image,
        et: 8,
      };

      window._swat.addToWatchList(event, params, (e) => {
        console.log('Subscribed to product!', e);
      });
    }

    addSwymVariantChangedEvent(swat) {
      swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, (data) => {
        const { variant, product } = data.detail.d;
        const currentUrl = window.location.href.split('?')[0];

        this.setAttribute('variant-id', variant.id);
        this.setAttribute('product-id', product.id);
        this.setAttribute('product-url', currentUrl);

        if (!variant.available) {
          this.button.classList.remove('swym-hide-button');
        } else {
          this.button.classList.add('swym-hide-button');
        }
      });
    }

    async fetchProductData(url) {
      try {
        const response = await fetch(`${url}.js`);
        if (!response.ok) return null;
        return await response.json();
      } catch (err) {
        console.error('Error fetching product data:', err);
        return null;
      }
    }
  }

  customElements.define('swymcs-watchlist-button', SwymCSWatchlistButton);
}
